export class UploadImageVO {
    imagenes: File;
    nombreTipoComponente: string;
    nombreTipoImagen: string;
    idComponente: number;
}